import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import WalkIn from '../components/WalkIn.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/walkin',
    name: 'Walkin',
    component: WalkIn
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
